<template>
  <b-card id="chart-card" class="card-padding">
    <b-skeleton-wrapper
      :loading="renderLoading"
      class="animate__animated animate__fadeIn"
    >
      <template #loading>
        <b-card-header>
          <div class="d-flex w-100 align-items-center chart-card-header">
            <b-skeleton-img width="40px" height="40px" />
            <b-skeleton width="26%" class="skeleton-header" />
          </div>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col cols="8" class="text-center">
              <b-skeleton width="100%" height="240px" />
            </b-col>
            <b-col cols="4" class="d-flex flex-column justify-content-center">
              <b-skeleton width="80%" />
              <b-skeleton width="100%" />
              <b-skeleton width="50%" />
              <b-skeleton width="70%" />
            </b-col>
          </b-row>
        </b-card-body>
      </template>
      <div class="animate__animated animate__fadeIn">
        <div class="p-absolute content-header-card chart">
          <div class="content-header-img">
            <img
              class="w-100"
              :src="$props.configCard.logo"
              alt=""
              draggable="false"
            />
          </div>
          <div class="content-header-name">
            <div>{{ $props.configCard.name }}</div>
          </div>
        </div>

        <b-card-body class="p-0">
          <div class="content-body-card">
            <v-chart
              ref="chartBar"
              class="chart-customer"
              :option="option"
              autoresize
            />
            <div class="content-legend">
              <div class="m-auto0 chart-description">
                <div
                  v-for="item in renderData"
                  :key="item.label"
                  class="d-flex flex-wrap mb-5px"
                >
                  <div
                    class="radius-color mr-1 "
                    :style="{ backgroundColor: item.color }"
                  />
                  <div class="name-legend">
                    {{ item.label }}
                  </div>
                  <div class="value-legend">
                    {{ formatter.format(item.value) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </div>
    </b-skeleton-wrapper>
  </b-card>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import { TooltipComponent } from "echarts/components";
import VChart from "vue-echarts";
use([CanvasRenderer, PieChart, TooltipComponent]);

import {
  ref,
  reactive,
  computed,
  getCurrentInstance,
  watch,
} from "@vue/composition-api";
import { formatter } from "@/utils/scripts/format-currency";

export default {
  components: {
    VChart,
  },
  props: {
    configCard: Object,
    dataBi: { type: Array, default: [] },
  },

  setup(props) {
    const vm = getCurrentInstance().proxy;

    const dataChart = reactive({
      data: [],
    });

    const option = reactive({
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)",
        textStyle: {
          fontFamily: "DBHelvethaicaX45Li",
          fontSize: 20,
        },
      },
      textStyle: {
        fontFamily: "DBHelvethaicaX45Li",
        fontSize: 24,
      },
      series: [
        {
          name: "Tier Summary",
          type: "pie",
          radius: ["30%", "60%"],
          avoidLabelOverlap: true,
          itemStyle: {
            borderRadius: 5,
            borderColor: "#fff",
            borderWidth: 1,
          },
          label: {
            show: true,
            formatter: "{b} : {d}%",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "28",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: true,
            length: 30
          },
          data: [],
        },
      ],
    });

    const renderData = computed(() => {
      dataChart.data = props.dataBi.find(
        (o) => o.id == props.configCard.id
      )?.data;
      return dataChart.data;
    });

    const renderLoading = computed(() => props.dataBi.length == 0);

    watch(
      dataChart,
      () => {
        vm.$nextTick(() => {
          if (dataChart.data?.length > 0) {
            let renderDataChart = [];
            dataChart.data.map((o) => {
              renderDataChart.push({
                value: o.value,
                name: o.label,
                itemStyle: { color: o.color },
              });
            });
            vm.$refs.chartBar?.setOption({
              series: [
                {
                  data: renderDataChart,
                },
              ],
            });
          }
        });
      },
      { deep: true }
    );

    return {
      option,
      formatter,
      renderData,
      renderLoading,
    };
  },
};
</script>

<style scoped>
.chart-customer {
  width: 70%;
  height: 380px;
}
</style>
